export enum AnalyticsEvent {
  AuthClientChanged = "auth_client_changed",
  CallOutError = "commuinication_call_out_error",
  CmdKFileUploadFileError = "cmd_k_file_upload_file_error",
  CmdKOpened = "cmd_k_opened",
  CmdKVisibilityChanged = "cmd_k_visibility_changed",
  KeyboardShortcutTriggered = "keyboard_shortcut_triggered",
  SelectedTemplateToGenerateResumeApplicationLink = "selected_template_to_generate_resume_application_link",
  TimeAgoToFullTimeUsed = "time_ago_to_full_time_used",
  TwilioDisconnectRetriesLimit = "twilio_disconnect_retries_limit",
  TwilioError = "twilio_error",
  TwilioIncomingCall = "twilio_incoming_call",
  TwilioOutgoingCall = "twilio_outgoing_call",
  WflDataOrchestrationRun = "workflow_live_data_orchestration_run",
  WflDealActivityTypeChanged = "workflow_live_deal_activity_type_changed",
  WflDealEmailThreadOpened = "workflow_live_deal_email_thread_opened",
  WflDealKilled = "workflow_live_deal_killed",
  WflDealStageChanged = "workflow_live_stage_changed",
  WflStageViewed = "workflow_live_stage_viewed",
  WflWorkflowLoaded = "workflow_live_workflow_loaded",

  // Inbox Events
  InboxViewChanged = "inbox_view_changed",
  InboxThreadOpened = "inbox_thread_opened",
  InboxThreadClosed = "inbox_thread_closed",
  InboxThreadSwitched = "inbox_thread_switched",

  // Data Orchestration Events
  DataOrchestrationTemplateViewed = "data_orchestration_template_viewed",
  DataOrchestrationTemplateCreated = "data_orchestration_template_created",
  DataOrchestrationTemplateSaved = "data_orchestration_template_saved",
  DataOrchestrationTemplateDeleted = "data_orchestration_template_deleted",
  DataOrchestrationBlockAdded = "data_orchestration_block_added",
  DataOrchestrationBlockDeleted = "data_orchestration_block_deleted",
  DataOrchestrationConditionAdded = "data_orchestration_condition_added",
  DataOrchestrationConditionUpdated = "data_orchestration_condition_updated",
  DataOrchestrationConditionDeleted = "data_orchestration_condition_deleted",

  // Scorecards Events
  ScorecardsTabChanged = "scorecards_tab_changed",
  ScorecardsViewChanged = "scorecards_view_changed",
  ScorecardCreated = "scorecard_created",
  ScorecardRun = "scorecard_run",
  ScorecardBlockAdded = "scorecard_block_added",
  ScorecardRunTriggered = "scorecard_run_triggered",
  ScorecardGroupRunTriggered = "scorecard_group_run_triggered",

  // Custom Webhooks Events
  CustomWebhookCreated = "custom_webhook_created",
  CustomWebhookUpdated = "custom_webhook_updated",
  CustomWebhookDeleted = "custom_webhook_deleted",
  CustomWebhookTriggered = "custom_webhook_triggered",

  // Command Bar Events
  CmdKAgentTriggered = "cmd_k_agent_triggered",
  CmdKSearchPerformed = "cmd_k_search_performed",
  CmdKModeChanged = "cmd_k_mode_changed",
  CmdKDealNavigated = "cmd_k_deal_navigated",
  CmdKDealOpenedNewTab = "cmd_k_deal_opened_new_tab",
  CmdKVoiceInputUsed = "cmd_k_voice_input_used",

  // Notes Events
  NoteVoiceInputUsed = "note_voice_input_used",

  // Deal List Search Events
  DealListSearchPerformed = "deal_list_search_performed",
  DealListSearchCategorySelected = "deal_list_search_category_selected",
  DealListSearchCleared = "deal_list_search_cleared",

  // Smart View Events
  SmartviewSwitched = "smartview_switched",
  SmartviewConfigureOpened = "smartview_configure_opened",
  SmartviewCreated = "smartview_created",
  SmartviewUpdated = "smartview_updated",
  SmartviewDeleted = "smartview_deleted",
  SmartviewDuplicated = "smartview_duplicated",
  SmartviewVisibilityToggled = "smartview_visibility_toggled",
  SmartviewReordered = "smartview_reordered",

  // Deal List Interaction Events
  DealListPageChanged = "deal_list_page_changed",
  DealListItemsPerPageChanged = "deal_list_items_per_page_changed",
  DealListColumnToggled = "deal_list_column_toggled",
  DealListMultiselectToggled = "deal_list_multiselect_toggled",

  // Deal View Events
  DealViewOpened = "deal_view_opened",
  DealViewDocumentViewed = "deal_view_document_viewed",
  DealViewDocumentUploaded = "deal_view_document_uploaded",

  // Deal Navigation Events
  DealNavSidebarItemClicked = "deal_nav_sidebar_item_clicked",
  DealHeaderMenuOptionSelected = "deal_header_menu_option_selected",
  DealStatusChanged = "deal_status_changed",

  // Application Link Events
  DealAppLinkGenerated = "deal_app_link_generated",
  DealTrackingViewed = "deal_tracking_viewed",

  // Stage Tab Events
  DealStageTabClicked = "deal_stage_tab_clicked",

  // Placement Events
  PlacementSectionViewed = "placement_section_viewed",
  PlacementFunderSelected = "placement_funder_selected",
  PlacementSubmitted = "placement_submitted",

  // Contract Builder Events
  ContractBuilderViewed = "contract_builder_viewed",
  ContractTemplateCreated = "contract_template_created",
  ContractTemplateEdited = "contract_template_edited",
  ContractTemplateDeleted = "contract_template_deleted",

  // Keyboard Shortcut Configuration Events
  KeyboardShortcutCustomized = "keyboard_shortcut_customized",
  KeyboardShortcutReset = "keyboard_shortcut_reset",

  // Communication Bar Events
  CommunicationEmailSent = "communication_email_sent",
  CommunicationSmsSent = "communication_sms_sent",
  CommunicationCallInitiated = "communication_call_initiated",
  CommunicationTaskCreated = "communication_task_created",
  CommunicationToolPinChanged = "communication_tool_pin_changed",
  QuickActionsOpened = "quick_actions_opened",
  QuickActionsCallInitiated = "quick_actions_call_initiated",
  QuickActionsSmsSent = "quick_actions_sms_sent",

  // Activity Modal Events
  ActivityModalOpened = "activity_modal_opened",
  ActivityTabTimeSpent = "activity_tab_time_spent",

  // Twilio PiP Events
  TwilioPipOpened = "twilio_pip_opened",
  TwilioPipClosed = "twilio_pip_closed",
  TwilioDeviceRegistered = "twilio_device_registered",
  TwilioTokenRefreshed = "twilio_token_refreshed",
  TwilioCallEnded = "twilio_call_ended",
  TwilioCallAccepted = "twilio_call_accepted",
  TwilioCallRejected = "twilio_call_rejected",
  TwilioCallDisconnected = "twilio_call_disconnected",
  TwilioRingtoneToggled = "twilio_ringtone_toggled",
  TwilioMicrophoneToggled = "twilio_microphone_toggled",
  TwilioKeypadToggled = "twilio_keypad_toggled",
  TwilioDtmfSent = "twilio_dtmf_sent",
  TwilioDialerReset = "twilio_dialer_reset",
  TwilioDialerResetError = "twilio_dialer_reset_error",
  TwilioAudioDeviceSelected = "twilio_audio_device_selected",

  // Smartview Cache Events
  SmartviewCacheHit = "smartview_cache_hit",
  SmartviewCacheMiss = "smartview_cache_miss",
  SmartviewCacheStale = "smartview_cache_stale",
  SmartviewCacheRemoved = "smartview_cache_removed",

  // Placement Additional Documents Events
  PlacementAdditionalDocsOpened = "placement_additional_docs_opened",
  PlacementAdditionalDocsUploaded = "placement_additional_docs_uploaded",
  PlacementAdditionalDocsSent = "placement_additional_docs_sent",

  // Email/SMS Templates Events
  EmailTemplateCreated = "email_template_created",
  EmailTemplateUpdated = "email_template_updated",
  EmailTemplateDeleted = "email_template_deleted",
  EmailTemplateUsed = "email_template_used",
  SmsTemplateCreated = "sms_template_created",
  SmsTemplateUpdated = "sms_template_updated",
  SmsTemplateDeleted = "sms_template_deleted",
  SmsTemplateUsed = "sms_template_used",
}
